var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Order") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Order",
    stroke: "none",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7909375,3.86275 L8.1875,0.05025 C8.0714746,-0.0167372981 7.9285254,-0.0167372981 7.8125,0.05025 L1.2090625,3.86275 C1.09304004,3.9297356 1.0215625,4.05352881 1.0215625,4.1875 L1.0215625,11.8125 C1.0215625,11.9464712 1.09304004,12.0702644 1.2090625,12.13725 L7.8125,15.94975 C7.9285254,16.0167373 8.0714746,16.0167373 8.1875,15.94975 L14.7909375,12.13725 C14.90696,12.0702644 14.9784375,11.9464712 14.9784375,11.8125 L14.9784375,4.1875 C14.9784375,4.05352881 14.90696,3.9297356 14.7909375,3.86275 Z M8,7.567 L5.44828125,6.09375 L11.3017188,2.71428125 L13.8534375,4.1875 L8,7.567 Z M8,0.80803125 L10.5517187,2.28125 L4.69828125,5.66075 L2.14659375,4.1875 L8,0.80803125 Z M1.7715625,4.837 L4.3246875,6.31109375 L4.3246875,9.82615625 C4.3246875,10.033263 4.49258072,10.2011563 4.6996875,10.2011563 C4.90679428,10.2011563 5.0746875,10.033263 5.0746875,9.82615625 L5.0746875,6.744125 L7.625,8.2165 L7.625,14.9754688 L1.7715625,11.5959688 L1.7715625,4.837 Z M8.375,14.9754687 L8.375,8.2165 L14.2284375,4.83703125 L14.2284375,11.5959687 L8.375,14.9754687 Z",
    id: "Shape",
    fill: "#726F7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/Order.24b1f66553d809d5e0f146e1f6ece1d7.svg";
export { ForwardRef as ReactComponent };